import type { AttachmentFile, SuretyBondId } from "@inrev/common";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { bondAttachmentsQueryKey } from "./bond.keys";

export const useFetchBondAttachments = (bondId: SuretyBondId) => {
	const { get } = useRequest();
	const { user } = useAuthenticatedUser();

	const isAdmin = user.type === "admin";

	const { data, error, isLoading } = useQuery({
		queryKey: bondAttachmentsQueryKey(bondId),
		queryFn: async () => {
			const url = isAdmin
				? `/v2/admin/surety/bonds/${bondId}/attachments`
				: `/v2/surety/bonds/${bondId}/attachments`;
			return await get<AttachmentFile[]>(url);
		},
	});

	return {
		attachments: data ?? [],
		attachmentsError: error,
		attachmentsIsLoading: isLoading,
	};
};
